// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"forest"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M12 15.9995L7 2.99951L2 15.9999L12 15.9995Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M12 15.9995L17 2.99951L22 15.9999L12 15.9995Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12 15.9995L17 2.99951L22 15.9999L12 15.9995ZM12 15.9995L7 2.99951L2 15.9999L12 15.9995ZM7 4L7 21M17 4V21","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ForestIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'forest',
    ref,
    icon: element,
  },
));

ForestIcon.displayName = 'ForestIcon';

export default ForestIcon;
